<template>
  <div v-if="isCN">
    <div ref="cloudflareCaptchaRef" />
    <p ref="cloudflareCaptchaErrorRef" class="hidden text-sm text-red-400">
      This field of information is required.
    </p>
  </div>
</template>

<script setup lang="ts">
  const emits = defineEmits<{
    (e: 'on-verify', value: { token: string; randomKey: string }): void;
    (e: 'on-expire'): void;
  }>();

  const { locale } = useI18n();
  const { isCN } = useLanguage();

  const cloudflareCaptchaRef = ref<HTMLElement | null>(null);
  const cloudflareCaptchaErrorRef = ref<HTMLElement | null>(null);
  const renderTimer = ref<NodeJS.Timeout | null>(null);

  const siteKey = computed(
    (): string => document.documentElement.dataset.captchaClientKey || ''
  );

  const renderCloudflare = (): void => {
    if (window.turnstile && typeof window.turnstile.render === 'function') {
      window.turnstile.ready(() => {
        window.turnstile.render(cloudflareCaptchaRef.value, {
          sitekey: siteKey.value,
          language: locale.value,
          theme: 'light',
          callback: (token: string) => {
            emits('on-verify', { token, randomKey: '' });
          },
          'expired-callback': () => {
            emits('on-expire');
          },
          'error-callback': () => {
            emits('on-expire');
            if (cloudflareCaptchaErrorRef.value) {
              (cloudflareCaptchaErrorRef.value as HTMLElement).style.display =
                'block';
            }
          },
        });
      });
    } else {
      renderTimer.value = setTimeout(() => {
        renderCloudflare();
      }, 600);
    }
  };

  onMounted(() => {
    if (isCN.value) {
      renderCloudflare();
    }
  });

  onBeforeUnmount(() => {
    if (renderTimer.value) {
      clearTimeout(renderTimer.value);
    }
  });
</script>
